<script>
	import axios from 'axios'
	import draftCommon from './draft-common.js'
	import dateUtil from '@uarmSrc/util-date.js'
	import modal from '@uarmSrc/modal.vue'

	export default {
		name: 'DraftBell',
		data: function() {
			return {
				draft_list: [],
				modalVisible_main: false,
				modalVisible_arm: false,
				draftToView: {},
				removedDrafts: {},
			}
		},
		computed: {
			c_armPredefinedFilter: function() {  // PIRS2018-3362
				return {
					_master_arm_id: this.$data.draftToView.armId,
					draft_master_id: this.$data.draftToView.id,
				}
			}
		},
		components: {
			modal
		},
		methods: {
			toggleModal: function(mainModalBoolean, armModalBoolean) {
				this.$data.modalVisible_main = !!mainModalBoolean;
				this.$data.modalVisible_arm = !!armModalBoolean;
				if (!armModalBoolean) {
					this.$data.draftToView = {};
				}
			},
			toggleModal_draftList: function(boo) {
				this.$data.modalVisible_main = !!boo;
			},
			toggleModal_diffArm: function(boo) {
				this.$data.modalVisible_arm = !!boo;
			},
			draftAccept: function(dr) {
				this.toggleModal(false, false);
				draftCommon.acceptance.setAndGo(dr);
			},
			draftView: function(dr) {
				this.toggleModal(false, true);
				this.$data.draftToView = dr;
			},
			draftRemove: function(dr) {
				var vm = this;
				this.toggleModal(false, false);

				// чтобы удаление не было сложным, сделал тупо так
				this.$data.removedDrafts[dr.id] = 1;
				if (Object.keys(this.$data.removedDrafts).length === this.$data.draft_list.length) {
					this.$data.draft_list.length = 0; // удалены все, скрываем колокольчик
				}

				draftCommon.doRemove(dr)
					.then(function(res) {
						draftCommon.log(res);
						vm.$notify({
							type: 'success',
							text: 'Черновик удалён',
						})
					})
					.catch(function(thrown){
						console.log(thrown)
					})

			},
		},
		mounted: function() {
			if (window.localStorage['DRAFT_SERVICE_DISABLE']) return; // чтобы не было бесячих надписей в консоли на ЛПТК
			var vm = this;

			// https://cwp.nu.oooinex.ru/draft/swagger-ui.html
			axios.get(draftCommon.serviceUrl)
				.then(function(res) {
					var data = res.data || {};
					if (data.success) {
						draftCommon.intervalMemory.set(data.draftInterval)
						if (!data.draftInterval) {
							return
						}
						draftCommon.log('Получено и установлено значение draft.interval: ' + data.draftInterval)
						vm.$data.draft_list = data.userDrafts || [];
						draftCommon.log('Получены черновики: ', data.userDrafts)
					}
					else {
						throw new Error('RID: ' + data.rid);
					}
				})
				.catch(function(thrown) {
					var status = thrown.response && thrown.response.status;
					var data = thrown.response && thrown.response.data;

					if (status === 403) {
						console.log('draft-bell: 403 Необходимо авторизоваться');
					}
					else if (status === 404) {
						console.log('draft-bell: 404 Ресурс недоступен');
					}
					else {
						console.log('draft-bell: Ошибка получения черновиков');
						console.log(thrown);
						if (data) {
							console.log(data);
						}
					}
				})
				.then(function() {

				})
		},
		filters: {
			prettyDate: function(d) {
				return dateUtil.isoToHuman(d)
			},
		}
	}


</script>

<template>
	<span v-if="$data.draft_list.length"> <!-- position: absolute; top: 20px; right: 20px; -->
		<i class="glyphicon glyphicon-bell" @click="toggleModal(true, false)" style="font-size: 30px; cursor: pointer;" ></i>
		<modal :visible.sync="modalVisible_main" :wide="true" :big_height="false">
			<div slot="header" class="row">
				<div class="col-md-12">
					<h3>Ваши черновики</h3>
				</div>
				<div class="col-md-12 text-right">
					<a class="btn btn-default btn-xs" @click="toggleModal(false, false)">Закрыть</a>
				</div>
			</div>
			<div slot="body">
				<table class="table table-striped table-hover table-bordered">
					<thead>
						<tr>
							<th>Логин</th>
							<th>Дата</th>
							<th>АРМ</th>
							<th>Сайт</th>
							<th>Запись</th>
							<th>Действие</th>
							<th style="min-width: 55ex;"><!-- кнопки --></th>
						</tr>
					</thead>
					<!-- id,armId,siteId,recordId,draftData,url,userIp,userName -->
					<tbody>
						<tr v-for="(dr) in $data.draft_list" :key="dr.id" :class="{'hidden': removedDrafts[dr.id]}">
							<td>{{dr.userName}}</td>
							<td>{{dr.dateCreate | prettyDate}}</td>
							<td>{{dr.armName}} [{{dr.armId}}]</td>
							<td>{{dr.siteName}} [{{dr.siteId}}]</td>
							<td>{{dr.recordName}} [{{dr.recordId}}]</td>
							<td>
								<template v-if="dr.recordId === 0">Создание</template>
								<template v-else>Редактирование</template>
							</td>
							<td>
								<a @click="draftView(dr)" class="btn btn-default">Просмотреть</a>&nbsp;
								<a @click="draftAccept(dr)" class="btn btn-primary">Принять изменения</a>&nbsp;
								<a @click="draftRemove(dr)" class="btn btn-danger">Удалить</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</modal>


		<modal :visible.sync="modalVisible_arm" :big_height="true" :wide="true" >
			<div slot="body">
				<global-component-page-list :arm_id="77732" :predefined_filter="c_armPredefinedFilter"  :pick_type="'draft_pick_type'" /> <!-- p_list.vue, доступен глобально из корня приложения - uarm (entry-point.js) и wizard (main.js) -->
			</div>
			<div slot="footer" class="footer">
				<div class="col-md-6">
					<a @click="draftAccept(draftToView)" class="btn btn-primary btn-block">Принять изменения</a>
				</div>
				<div class="col-md-6">
					<a @click="draftRemove(draftToView)" class="btn btn-danger btn-block">Удалить черновик</a>
				</div>
				<div class="col-md-6">
					<a @click="toggleModal(true, false)" class="btn btn-default btn-block">Вернуться</a>
				</div>
				<div class="col-md-6">
					<a @click="toggleModal(false, false)" class="btn btn-default btn-block">Закрыть</a>
				</div>
			</div>
		</modal>

	</span>
</template>

<style>

</style>
